var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPromoHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.75L18.75 11.25",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12.5C12.2202 12.5 12.5 12.2202 12.5 11.875C12.5 11.5298 12.2202 11.25 11.875 11.25C11.5298 11.25 11.25 11.5298 11.25 11.875C11.25 12.2202 11.5298 12.5 11.875 12.5Z",
    fill: "#3653C7",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18.75C18.4702 18.75 18.75 18.4702 18.75 18.125C18.75 17.7798 18.4702 17.5 18.125 17.5C17.7798 17.5 17.5 17.7798 17.5 18.125C17.5 18.4702 17.7798 18.75 18.125 18.75Z",
    fill: "#3653C7",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2496 8.9996C6.2496 8.27025 6.53933 7.57078 7.05506 7.05506C7.57078 6.53933 8.27025 6.2496 8.9996 6.2496H10.2496C10.9757 6.24918 11.6722 5.9616 12.1871 5.4496L13.0621 4.5746C13.3177 4.3176 13.6215 4.11365 13.9562 3.97448C14.2908 3.83532 14.6497 3.76367 15.0121 3.76367C15.3745 3.76367 15.7334 3.83532 16.068 3.97448C16.4027 4.11365 16.7065 4.3176 16.9621 4.5746L17.8371 5.4496C18.352 5.9616 19.0485 6.24918 19.7746 6.2496H21.0246C21.7539 6.2496 22.4534 6.53933 22.9691 7.05506C23.4849 7.57078 23.7746 8.27025 23.7746 8.9996V10.2496C23.775 10.9757 24.0626 11.6722 24.5746 12.1871L25.4496 13.0621C25.7066 13.3177 25.9105 13.6215 26.0497 13.9562C26.1889 14.2908 26.2605 14.6497 26.2605 15.0121C26.2605 15.3745 26.1889 15.7334 26.0497 16.068C25.9105 16.4027 25.7066 16.7065 25.4496 16.9621L24.5746 17.8371C24.0626 18.352 23.775 19.0485 23.7746 19.7746V21.0246C23.7746 21.7539 23.4849 22.4534 22.9691 22.9691C22.4534 23.4849 21.7539 23.7746 21.0246 23.7746H19.7746C19.0485 23.775 18.352 24.0626 17.8371 24.5746L16.9621 25.4496C16.7065 25.7066 16.4027 25.9105 16.068 26.0497C15.7334 26.1889 15.3745 26.2605 15.0121 26.2605C14.6497 26.2605 14.2908 26.1889 13.9562 26.0497C13.6215 25.9105 13.3177 25.7066 13.0621 25.4496L12.1871 24.5746C11.6722 24.0626 10.9757 23.775 10.2496 23.7746H8.9996C8.27025 23.7746 7.57078 23.4849 7.05506 22.9691C6.53933 22.4534 6.2496 21.7539 6.2496 21.0246V19.7746C6.24918 19.0485 5.9616 18.352 5.4496 17.8371L4.5746 16.9621C4.3176 16.7065 4.11365 16.4027 3.97448 16.068C3.83532 15.7334 3.76367 15.3745 3.76367 15.0121C3.76367 14.6497 3.83532 14.2908 3.97448 13.9562C4.11365 13.6215 4.3176 13.3177 4.5746 13.0621L5.4496 12.1871C5.9616 11.6722 6.24918 10.9757 6.2496 10.2496V8.9996",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPromoHub);
export default __webpack_public_path__ + "static/media/menu_promo_hub.ad43d41f.svg";
export { ForwardRef as ReactComponent };